export const POST_PAYMENT_FEEDBACK_REACTIONS = {
  GOOD_REACTION: 'post_pay_feedback_good',
  NEUTRAL_REACTION: 'post_pay_feedback_neutral',
  BAD_REACTION: 'post_pay_feedback_bad',
};
